export interface CosmosGlobals {}

declare global {
  interface Window {
    cosmos: CosmosGlobals;
  }
}

if (typeof window !== 'undefined' && !window.cosmos) {
  Object.defineProperty(window, 'cosmos', { value: {} });
}
